import { render } from "./Avatar.vue?vue&type=template&id=73cb2ce6"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
script.render = render

export default script